import { useNavigate } from "react-router-dom";

export default function Landing() {
  const navigate = useNavigate();
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");

  const container: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    background: "#0a1a12",
    fontFamily: "'Inter', system-ui, sans-serif",
    padding: 32,
  };

  const btnPrimary: React.CSSProperties = {
    width: "100%",
    padding: "14px 0",
    fontSize: 15,
    fontWeight: 600,
    borderRadius: 8,
    border: "none",
    background: "#00894F",
    color: "#fff",
    cursor: "pointer",
    transition: "background 0.2s",
  };

  const btnSecondary: React.CSSProperties = {
    width: "100%",
    padding: "14px 0",
    fontSize: 15,
    fontWeight: 500,
    borderRadius: 8,
    border: "1px solid rgba(0,137,79,0.4)",
    background: "transparent",
    color: "#edf2ef",
    cursor: "pointer",
    transition: "border-color 0.2s",
  };

  return (
    <div style={container}>
      <div style={{ maxWidth: 420, width: "100%", textAlign: "center" }}>
        <div style={{ marginBottom: 48 }}>
          <h1
            style={{
              color: "#edf2ef",
              fontSize: 36,
              fontWeight: 700,
              marginBottom: 12,
              letterSpacing: -0.5,
            }}
          >
            Thread
          </h1>
          <p
            style={{
              color: "#b8c8c0",
              fontSize: 15,
              lineHeight: 1.6,
              margin: 0,
            }}
          >
            Provenance tracking for computational workflows
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <button style={btnPrimary} onClick={() => navigate("/sign-in")}>
            Click here to Login
          </button>
          <a
            href={`${base}/site/`}
            style={{ ...btnSecondary, display: "block", textDecoration: "none", lineHeight: "1.5" }}
          >
            Click here to see Thread Media
          </a>
        </div>
      </div>
    </div>
  );
}
